//TODO: 修改数据结构，使用服务端返回的 level 和 unit。改完后需要更新 vip 外教

import React from "react";
import { COURSE, COURSE_API } from "../utils/Req";
import { Utils } from "../utils/Utils";
import { setUserStorage } from '../server/commonFun';
import lottie from "lottie-web";
import $ from "jquery";

import "../static/css/my-gift.scss";

const POSITION = [
    { top: "90px", left: "193px", width: "200px", height: "175px" },
    { top: "90px", left: "368px", width: "250px", height: "150px" },
    { top: "90px", left: "593px", width: "200px", height: "175px" },
    { top: "240px", left: "193px", width: "225px", height: "150px" },
    { top: "215px", left: "393px", width: "200px", height: "175px" },
    { top: "240px", left: "568px", width: "225px", height: "150px" }
];

const Complate_Gift_Position = [
    { top: "0px", left: "0px", width: "200px", height: "175px" },
    { top: "0px", left: "175px", width: "250px", height: "150px" },
    { top: "0px", left: "400px", width: "200px", height: "175px" },
    { top: "150px", left: "0px", width: "225px", height: "150px" },
    { top: "125px", left: "200px", width: "200px", height: "175px" },
    { top: "150px", left: "375px", width: "225px", height: "150px" }
];

const FTop = 468;
const FLeft = 136;

let showPuzzleTimer;

let ZINDEX = 1;
let newGuide;
let clickFlag = true;
let isMoving = false;

// 取出 putaoid 和 token
export default class MyGift extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentLevel: 1,
            currentUnit: {
                level: 1,
                unit: 1
            },
            showLesson: false,
            currentImage: "",
            tempAllStorage: null,
            showPuzzle: false,
            FirstGift: false,
            clickFlag: true,
            isMoving: false,   // 是否是正在拖拽中
            isEmptyGift: false,   //  是否一个礼物碎片都没有
        };

        this.PutaoID = Utils.getCookie("putaoid");
        this.Token = encodeURIComponent(Utils.getCookie("token"));
        this.notFirstGift = window.localStorage.getItem(
            `notFirstGift-${this.PutaoID}`
        );
    }

    componentDidMount() {
        const that = this;
        // 获取当前要显示的拼图
        this.getCurrentLevelUnit();
        this.getTempStorage();

        // 如果是新用户，过六秒没有交互就出现用户指引

        if (!this.notFirstGift) {
            this.newGuideTimeOut = setTimeout(() => {
                this.setState({ FirstGift: true }, () => {
                    window.localStorage.setItem(
                        `notFirstGift-${that.PutaoID}`,
                        "true"
                    );
                    // const tempTimer = setTimeout(() => {
                    // console.log("事件到了", newGuide);
                    // 小手的动画
                    if (newGuide) {
                        // console.log($(".my-gift-content-new-guide"));
                        const p = POSITION[newGuide.imageId - 1];
                        const p_left = $(".my-gift-content-new-guide").css(
                            "left"
                        );
                        const p_top = $(".my-gift-content-new-guide").css(
                            "top"
                        );
                        // console.log(
                        //   $(".my-gift-content-new-guide").css("left"),
                        //   $(".my-gift-content-new-guide").css("top")
                        // );
                        $(".my-gift-content-new-guide").animate(
                            {
                                width: p.width,
                                height: p.height,
                                left: parseInt(p_left, 10) - 50 + "px",
                                top: parseInt(p_top, 10) - 50 + "px"
                            },
                            500
                        );
                        $(".my-gift-content-new-guide").animate(
                            {
                                left: p.left,
                                top: p.top
                            },
                            1500,
                            function () {
                                $(".my-gift-content-new-guide").animate(
                                    {
                                        left: parseInt(p_left, 10) - 50 + "px",
                                        top: parseInt(p_top, 10) - 50 + "px"
                                    },
                                    0,
                                    function () {
                                        $(".my-gift-content-new-guide").animate(
                                            {
                                                left: p.left,
                                                top: p.top
                                            },
                                            1500,
                                            function () {
                                                that.setState({
                                                    FirstGift: false
                                                });
                                            }
                                        );
                                    }
                                );
                            }
                        );
                    }
                    //   clearTimeout(tempTimer);
                    // }, 1000);
                });
            }, 6000);
        }
    }

    componentWillUnmount() {
        clearTimeout(showPuzzleTimer);
    }

    // 获取当前的 level 和 unit
    getCurrentLevelUnit(e) {
        const cid = Utils.getHashQueryString("cid");

        // 先获取用户的信息，得到当前用户的等级、单元、课程
        fetch(
            `${COURSE_API.user}?putaoid=${this.PutaoID}&token=${this.Token
            }&from=pc`,
            {
                method: "GET"
            }
        )
            .then(res => res.json())
            .then(data => {
                if (data.code === 499) {
                    window.location.href = `${window.location.pathname}${window.location.search}#/login?redirect=my-gift`;
                }
                if (data.code === 200) {
                    setUserStorage(data);
                    if (cid) {
                        const tempCourseInfo = cid.split("_");

                        this.setState({
                            currentLevel: Number(tempCourseInfo[0]),
                            currentUnit: {
                                level: Number(tempCourseInfo[0]),
                                unit: Number(tempCourseInfo[1])
                            }
                        });

                        if (
                            Number(tempCourseInfo[2]) === 1 &&
                            Number(tempCourseInfo[0]) > 1
                        ) {
                            this.changeUnitHandler(
                                e,
                                Number(tempCourseInfo[1]) - 1,
                                -1
                            );
                        }
                    } else {
                        this.setState({
                            currentLevel: data.course_position.level ? data.course_position.level : 0,
                            currentUnit: {
                                level: data.course_position.level ? data.course_position.level : 0,
                                unit: data.course_position.unit ? data.course_position.unit : 0
                            }
                        });
                    }

                    // 请求所有的礼物
                    fetch(
                        `${COURSE_API.gift_list}?token=${this.Token}&putaoid=${this.PutaoID
                        }&from=pc`,
                        {
                            method: "GET"
                        }
                    )
                        .then(res => res.json())
                        .then(data => {
                            const { currentUnit } = this.state;
                            const level = currentUnit.level;
                            const unit = currentUnit.unit;

                            if (data.code === 200) {
                                if (data.gift.length <= 0) {
                                    this.setState({
                                        levels: null,
                                        units: null,
                                        unitGiftInfo: null,
                                        isEmptyGift: true
                                    });
                                    return;
                                }
                                const levels = [];
                                const units = [];
                                let unitTemp = [];
                                let giftLength = 0;
                                for (var i = 0; i < data.gift.length; i++) {
                                    levels.push(data.gift[i] && data.gift[i].level ? data.gift[i].level : 0);   // 使用服务端返回的 level
                                }
                                for (var j = 0; j < levels.length; j++) {
                                    unitTemp = [];
                                    for (var k = 0; k < data.gift[j].units.length; k++) {
                                        unitTemp.push(data.gift[j].units[k] && data.gift[j].units[k].unit ? data.gift[j].units[k].unit : 0);
                                        giftLength += 1;
                                    }
                                    units.push(unitTemp);
                                }

                                // ===================
                                // const levels = [0, 1];
                                // const units = [[0, 1, 2, 3, 4, 5], [0, 1, 2, 3, 4, 5]];

                                this.setState(
                                    {
                                        levels: levels,
                                        units: units,
                                        gifts: data.gift,
                                        BGArr: ["1", "2", "3", "4", "5", "6"],
                                        giftLength: giftLength
                                    },
                                    () => {
                                        this.getTempStorage();
                                    }
                                );
                            }
                        });
                }
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentUnit.unit !== prevState.currentUnit.unit) {
            this.getTempStorage();
        } else if (this.state.updateStorage === true) {
            this.getTempStorage();
        }
    }

    // 获取 localstorage 拼图，组件中只获取一次。一进来的时候把所有的都获取到
    getTempStorage() {
        const { levels, units } = this.state;
        let length;
        let key;
        let string;
        let fragments;
        let ids;
        let imgs;
        const tempAllStorage = {};

        if (!levels || !units) {
            return;
        }

        for (let i = 0; i < levels.length; i++) {
            length = units[i].length;
            for (let j = 0; j < length; j++) {
                key = `level${i + 1}-unit${j + 1}-${this.PutaoID}`;
                string = window.localStorage.getItem(key);
                if (string) {
                    fragments = string.split(",");
                } else {
                    fragments = [];
                }

                ids = fragments.map(value => value.split("&")[0]);
                imgs = fragments.map(value => value.split("&")[1]);

                tempAllStorage[key] = {
                    fragments,
                    ids,
                    imgs
                };
            }
        }

        this.setState({
            tempAllStorage
        });
    }

    //切换到其他的礼物
    changeUnitHandler(e, index, des) {
        if (e) {
            e.preventDefault();
        }
        var tempIndex = index;
        let { currentLevel, units } = this.state;
        // console.log(des);

        if (index < 1 && units) {
            currentLevel = currentLevel - 1;
            tempIndex = units[currentLevel - 1] && units[currentLevel - 1].length;
        }

        if (index > this.maxUnit) {
            tempIndex = 1;
            currentLevel = currentLevel + 1;
        }

        console.log(e, index, des)

        this.setState({
            currentLevel,
            currentUnit: {
                level: currentLevel,
                unit: tempIndex
            },
            des: des
        });
    }

    // 关闭当前的 all-lesson-list
    closeAllLessonList(e) {
        const { showLesson, isEmptyGift } = this.state;

        if (isEmptyGift) {
            return;
        }

        if (
            e.target.id === "get-all-lesson-button" ||
            e.target.id === "get-all-lesson"
        ) {
            this.setState({
                showLesson: !showLesson
            });
        } else if (
            e.target.nodeName !== "LI" ||
            e.target.className === "lesson-unit"
        ) {
            this.setState({
                showLesson: false
            });
        }
    }

    // 不使用原生的拖拽事件。使用 mouseMove 和 mouseUp 事件来控制被拖动元素的位置。所有的位置现在都以最外面得盒子作为基准
    // 问题:
    // 1.取消不掉 onMouseMove 事件
    // 2.点击的时候元素变大，并且鼠标位于中间部分；（计算位置根据鼠标，这里需要计算外面的大盒子相对于视口的距离）
    MoveImageHandler(id, index, imageUrl, e) {
        e.persist();

        // 只有在左击的情况下才认为是移动
        if ((e.button !== undefined && e.button !== null && e.button !== 0) || isMoving) {
            return;
        }

        // 设置 700 毫秒间隔
        if (clickFlag) {
            clickFlag = false;
            e.target.style.cursor = "default";
            setTimeout((e) => {
                clickFlag = true;
                e.target.style.cursor = "pointer";
            }, 700, e);
        } else {
            return;
        }

        this.targetElement = e;

        // 防止完成拼图后还能动
        if (this.targetElement.target.className.indexOf("has-down") > -1) {
            e.preventDefault();
            return;
        }

        this.targetElement.target.style.zIndex = ZINDEX;
        ZINDEX++;
        // 获取礼物的容器相对于视口的距离()
        const gift_con = document.querySelector(".gift-content");

        this.gift_con_left = parseInt(
            gift_con.offsetLeft - gift_con.offsetWidth / 2,
            10
        );
        this.gift_con_top = parseInt(
            gift_con.offsetTop - gift_con.offsetHeight / 2,
            10
        );

        // 记录当前的位置 计算将要放置的地方
        this.target_left = this.targetElement.target.style.left;
        this.target_top = this.targetElement.target.style.top;

        this.targetStartX = parseInt(POSITION[id - 1].left, 10);
        this.targetEndX =
            parseInt(POSITION[id - 1].left, 10) +
            parseInt(POSITION[id - 1].width, 10);
        this.targetStartY = parseInt(POSITION[id - 1].top, 10);
        this.targetEndY =
            parseInt(POSITION[id - 1].top, 10) +
            parseInt(POSITION[id - 1].height, 10);

        document.onmousemove = this.fnMove.bind(this, id, index);
        document.onmouseup = this.fnUp.bind(this, id, index, imageUrl);
    }

    fnMove(id, index, event, type) {
        event.persist && event.persist();

        let moveElement = event;

        // 防止完成拼图后还能动
        if (this.targetElement.target.className.indexOf("has-down") > -1) {
            event.preventDefault();
            return;
        }

        if (event.targetTouches) {
            moveElement = event.targetTouches[0] || event.changedTouches[0];
        }
        // if (type === 'touch') {
        //   moveElement = event.targetTouches[0];
        // }

        this.targetElement.target.style.width =
            parseInt(POSITION[id - 1].width, 10) + "px";
        this.targetElement.target.style.height =
            parseInt(POSITION[id - 1].height, 10) + "px";

        this.targetElement.target.style.left =
            moveElement.clientX -
            this.gift_con_left -
            parseInt(parseInt(POSITION[id - 1].width, 10) / 2, 10) +
            "px";
        this.targetElement.target.style.top =
            moveElement.clientY -
            this.gift_con_top -
            parseInt(parseInt(POSITION[id - 1].height, 10) / 2, 10) +
            "px";

        // // 修改状态为正在拖拽中
        // this.setState({
        //     isMoving: true
        // })
        isMoving = true;
    }

    // 判断是不是放在了对应的里面
    fnUp(id, index, imageUrl, e) {
        // 防止完成拼图后还能动
        if (this.targetElement.target.className.indexOf("has-down") > -1) {
            e.preventDefault();
            return;
        }

        // 之前重复添加是因为鼠标的 mouseup 事件还在，所以一直触发添加
        const that = this;
        const { currentUnit, currentLevel, tempAllStorage } = that.state;

        this.targetElement.persist && this.targetElement.persist();

        var positionX = parseInt(this.targetElement.target.style.left, 10);
        var positionEndX =
            positionX + parseInt(this.targetElement.target.style.width, 10);
        var positionY = parseInt(this.targetElement.target.style.top, 10);
        var positionEndY =
            positionY + parseInt(this.targetElement.target.style.height, 10);

        // 添加音效
        const play_sound = document.getElementById("play-sound");

        clearTimeout(this.newGuideTimeOut);

        if (
            positionX > that.targetStartX - 50 &&
            positionEndX < that.targetEndX + 50 &&
            (positionY > that.targetStartY - 50 &&
                positionEndY < that.targetEndY + 50)
        ) {
            this.targetElement.target.onmousedown = null;
            this.targetElement.target.ontouchstart = null;
            $(this.targetElement.target)
                .animate(
                    {
                        left: that.targetStartX + "px",
                        top: that.targetStartY + "px"
                    },
                    300,
                    function () {
                        // 在这里判断是不是到了 6 个，发送成功请求
                        if (tempFragments.length >= 6) {
                            that.showComplatePuzzle();
                        }

                        // 修改状态为未拖拽中
                        // this.setState({
                        //     isMoving: false
                        // })
                        isMoving = false;
                    }
                )
                .addClass("has-down");

            const key = `level${currentUnit.level}-unit${currentUnit.unit}-${this.PutaoID
                }`;
            const tempFragments = tempAllStorage[key].fragments;

            tempFragments.push(`${id}&${imageUrl}`);
            window.localStorage.setItem(key, tempFragments);

            // 添加成功音效
            if (play_sound) {
                // play_sound.src = "/onlinepages/course_h5/source/drag_right.mp3";
                play_sound.src =
                    "https://putaoabc.com/onlinepages/course_h5/source/drag_right.mp3";
            }
        } else {
            $(this.targetElement.target).animate(
                {
                    left: this.target_left,
                    top: this.target_top,
                    width: "87px",
                    height: "75px"
                },
                500,
                function () {
                    isMoving = false;
                }
            );

            if (play_sound) {
                // play_sound.src = "/onlinepages/course_h5/source/drag_wrong.mp3";
                play_sound.src =
                    "https://putaoabc.com/onlinepages/course_h5/source/drag_wrong.mp3";
            }
        }
        document.onmousemove = null;
        document.onmouseup = null;
    }

    // 显示完整的拼图
    showComplatePuzzle() {
        // console.log("拼图完成");
        const { currentUnit } = this.state;
        this.setState(
            {
                showPuzzle: true
            },
            () => {
                showPuzzleTimer = setTimeout(() => {
                    const giftElement = document.getElementById("gift_piece");
                    // console.log("获取元素", giftElement);
                    if (giftElement) {
                        lottie.loadAnimation({
                            container: giftElement, //包含动画的DOM元素
                            renderer: "svg",
                            loop: true,
                            autoplay: true,
                            path: window.publicUrl + "static/lottie/piece.json" //动画的路径
                        });
                    }

                    const play_sound = document.getElementById("play-sound");

                    if (play_sound) {
                        play_sound.src =
                            "https://courses-1256571289.cos.ap-beijing.myqcloud.com/level1/unit1/lesson2/1540280916/resource/audio/game_finish.mp3";
                    }
                }, 1000);
            }
        );

        // 发送完成的请求
        fetch(
            `${COURSE_API.save_gift}?putaoid=${this.PutaoID}&token=${this.Token
            }&level=${currentUnit.level}&unit=${currentUnit.unit}&from=pc`,
            { method: "GET" }
        )
            .then(res => res.json())
            .then(data => { });
    }

    // 根据当前索引值获取 level 和 unit 的值（其实顺序返回和没有顺序，区别就在于显示，加上一个获取 level 和 unit 的函数就好，不需要改太复杂的逻辑）
    getLevelHandler() {
        const { currentUnit, levels } = this.state;
        let level = '';

        if (currentUnit.level && levels && levels[currentUnit.level - 1]) {
            level = levels[currentUnit.level - 1];
        }

        return level;
    }

    // 根据当前索引值获取 level 和 unit 的值
    getUnitHandler() {
        const { currentUnit, units } = this.state;
        let unit = '';

        if (currentUnit.level && units && units[currentUnit.level - 1] && units[currentUnit.level - 1][currentUnit.unit - 1]) {
            unit = units[currentUnit.level - 1][currentUnit.unit - 1];
        }

        return unit;
    }

    render() {
        const that = this;

        const {
            showLesson,
            levels,
            units,
            currentUnit,
            currentLevel,
            BGArr,
            gifts,
            tempAllStorage,
            showPuzzle,
            des,
            FirstGift,
            isEmptyGift
        } = this.state;
        const key = `level${currentUnit.level}-unit${currentUnit.unit}-${this.PutaoID
            }`;
        let unitGiftInfo;
        let unitGiftInfoLessons;
        let tempStorageId;
        let tempStorageImg;

        if (tempAllStorage && tempAllStorage[key]) {
            tempStorageId = tempAllStorage[key].ids;
            tempStorageImg = tempAllStorage[key].imgs;
        }

        //  记录最大的 level，当前 unit 的最大值
        if (levels) {
            this.maxLevel = levels.length;
            this.maxUnit = units[currentLevel - 1] && units[currentLevel - 1].length;

            // 原本返回的数据
            unitGiftInfo = gifts[currentUnit.level - 1] && gifts[currentUnit.level - 1].units[currentUnit.unit - 1];

            // 默认选中当前，如果当前为空，就往前走一个
            if (!unitGiftInfo) {
                (function (e) {
                    if (currentLevel && currentUnit && currentUnit.unit) {
                        (currentUnit.unit !== 1 || currentLevel !== 1) && that.changeUnitHandler(e, currentUnit.unit - 1, -1)
                    }
                })()
            }

            // 对当前要显示的进行处理，把没有拼的放前面，拼过的放后面
            // 想法是：先把数据分成两个数组，然后合起来，再遍历，如果在当前的数组，把再 localStorage 中的放到后面
            var tempUnitGiftInfoLessons =
                gifts[currentUnit.level - 1] &&
                gifts[currentUnit.level - 1].units[currentUnit.unit - 1] &&
                gifts[currentUnit.level - 1].units[currentUnit.unit - 1]
                    .lessons;
            var lockedArr = [];
            var unLockedArr = [];

            tempUnitGiftInfoLessons &&
                tempUnitGiftInfoLessons.forEach(value => {
                    if (value) {
                        if (value.locked === true) {
                            lockedArr.push(value);
                        } else {
                            unLockedArr.push(value);
                        }
                    }
                });
            tempUnitGiftInfoLessons = unLockedArr.concat(lockedArr);

            // console.log(tempStorageId);
            if (tempStorageId) {
                unitGiftInfoLessons = lockedArr;
                unLockedArr.forEach((value, index) => {
                    if (tempStorageId.indexOf(value.imageId.toString()) >= 0) {
                        unitGiftInfoLessons.push(value);
                    } else {
                        unitGiftInfoLessons.unshift(value);
                    }
                });
            }

            // 用来显示小手（找到一个可用的）
            // for (let i = 0; i < unitGiftInfo.lessons.length; i++) {
            //   if (unitGiftInfo.lessons[i].locked === false) {
            //     newGuide = Object.assign({}, unitGiftInfo.lessons[i], { index: i });
            //     break;
            //   }
            // }
            if (unitGiftInfoLessons) {
                for (let i = 0; i < unitGiftInfoLessons.length; i++) {
                    if (unitGiftInfoLessons[i].locked === false) {
                        newGuide = Object.assign({}, unitGiftInfoLessons[i], {
                            index: i
                        });
                        break;
                    }
                }
            }
        }
        if (!levels) {
            this.maxLevel = 1;
        }

        return (
            <div
                className="my-gift"
                onClick={e => {
                    this.closeAllLessonList(e);
                }}
            >
                <div
                    className="my-gift-return"
                    onClick={() => {
                        window.history.back();
                    }}
                />
                <div className="my-gift-title">我的礼物</div>
                <div className="gift-content">
                    <div className="gift-content-header">
                        {/* <div
              className={
                currentUnit.unit === 1 && currentLevel === 1
                  ? "gift-header-left gift-header-unclick"
                  : "gift-header-left"
              }
              onClick={e => {
                (currentUnit.unit !== 1 || currentLevel !== 1) &&
                  this.changeUnitHandler(e, currentUnit.unit - 1, -1);
              }}
            /> */}
                        <div
                            className="current-level-unit"
                            id="get-all-lesson-button"
                            onClick={e => {
                                this.closeAllLessonList(e);
                            }}
                        >
                            Level{this.getLevelHandler()}, Unit{this.getUnitHandler()}
                            <span
                                className="current-level-unit-button"
                                id="get-all-lesson"
                            />
                        </div>
                        {showLesson && (
                            <div className={"all-lesson-list"}>
                                <ul className="all-lesson-kind">
                                    {levels &&
                                        levels.map((value, index) => (
                                            <li
                                                key={index}
                                                className={
                                                    index === currentLevel - 1
                                                        ? "on lesson-level"
                                                        : "lesson-level"
                                                }
                                                onClick={() => {
                                                    this.setState({
                                                        currentLevel: index + 1
                                                    });
                                                }}
                                            >
                                                Level{value}
                                            </li>
                                        ))}
                                </ul>
                                <div className="all-lesson-unit-box">
                                    <ul className="all-lesson-unit">
                                        {units &&
                                            units[currentLevel - 1] &&
                                            units[currentLevel - 1].map(
                                                (value, index) => (
                                                    <li
                                                        key={index}
                                                        className={
                                                            currentUnit.level ===
                                                                currentLevel &&
                                                                currentUnit.unit ===
                                                                index + 1
                                                                ? "on lesson-unit"
                                                                : "lesson-unit"
                                                        }
                                                        onClick={e => {
                                                            this.changeUnitHandler(
                                                                e,
                                                                index + 1,
                                                                1
                                                            );
                                                        }}
                                                    >
                                                        Unit{value}
                                                    </li>
                                                )
                                            )}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {/* <div
              className={
                currentUnit.unit ===
                  (units && units[currentLevel - 1]
                    ? units[currentLevel - 1].length
                    : 1) && currentLevel === this.maxLevel
                  ? "gift-header-right gift-header-unclick"
                  : "gift-header-right"
              }
              onClick={e => {
                (currentUnit.unit !==
                  (units ? units[currentLevel - 1].length : 1) ||
                  currentLevel !== this.maxLevel) &&
                  this.changeUnitHandler(e, currentUnit.unit + 1, 1);
              }}
            /> */}
                    </div>
                    {/* 左右箭头 */}
                    {unitGiftInfo && (
                        <div
                            className={
                                currentUnit.unit === 1 && currentLevel === 1
                                    ? "gift-header-unclick"
                                    : "gift-header-left"
                            }
                            onClick={e => {
                                (currentUnit.unit !== 1 ||
                                    currentLevel !== 1) &&
                                    this.changeUnitHandler(
                                        e,
                                        currentUnit.unit - 1,
                                        -1
                                    );
                            }}
                            style={{
                                zIndex: 999,
                                position: "absolute",
                                left: "80px",
                                top: "200px",
                                width: "100px",
                                height: "100px"
                            }}
                        />
                    )}
                    {unitGiftInfo && (
                        <div
                            className={
                                currentUnit.unit ===
                                    (units && units[currentLevel - 1]
                                        ? units[currentLevel - 1].length
                                        : 1) && currentLevel === this.maxLevel
                                    ? "gift-header-unclick"
                                    : "gift-header-right"
                            }
                            onClick={e => {
                                (currentUnit.unit !==
                                    (units
                                        ? units[currentLevel - 1].length
                                        : 1) ||
                                    currentLevel !== this.maxLevel) &&
                                    this.changeUnitHandler(
                                        e,
                                        currentUnit.unit + 1,
                                        1
                                    );
                            }}
                            style={{
                                zIndex: 999,
                                position: "absolute",
                                right: "60px",
                                top: "200px",
                                width: "100px",
                                height: "100px"
                            }}
                        />
                    )}

                    {levels &&
                        Array.isArray(levels) &&
                        levels.map((valueL, indexL) => {
                            return units[indexL].map((valueU, indexU) => {
                                var key = `level${indexL + 1}-unit${indexU +
                                    1}-${this.PutaoID}`;
                                var Id =
                                    tempAllStorage &&
                                    tempAllStorage[key] &&
                                    tempAllStorage[key].ids;
                                var Img =
                                    tempAllStorage &&
                                    tempAllStorage[key] &&
                                    tempAllStorage[key].imgs;
                                return (
                                    <div
                                        key={indexL + "_" + indexU}
                                        // 把前一个和后一个定位到最边边
                                        className={
                                            des
                                                ? // (indexL + 1 === currentLevel &&
                                                indexL + 1 ===
                                                    currentUnit.level &&
                                                    indexU + 1 ===
                                                    currentUnit.unit
                                                    ? des < 0
                                                        ? "slide-left"
                                                        : "slide-right"
                                                    : des < 0
                                                        ? "slide-out-right"
                                                        : "slide-out-left"
                                                : ""
                                        }
                                        style={{
                                            zIndex:
                                                // indexL + 1 === currentLevel &&
                                                indexL + 1 ===
                                                    currentUnit.level &&
                                                    indexU + 1 === currentUnit.unit
                                                    ? 0
                                                    : -1,
                                            position: "absolute",
                                            width: "900px",
                                            height: "300px"
                                        }}
                                    >
                                        {/* 如果拼图已经完成，就直接填入，否则显示每个占位 */}
                                        {unitGiftInfo &&
                                            unitGiftInfo.finish === true &&
                                            clearTimeout(this.newGuideTimeOut)}
                                        {unitGiftInfo &&
                                            unitGiftInfo.finish === true && // <div>已经完成</div>
                                            unitGiftInfoLessons &&
                                            Array.isArray(
                                                unitGiftInfoLessons
                                            ) &&
                                            unitGiftInfoLessons.map(
                                                (value, index) => {
                                                    var position =
                                                        Complate_Gift_Position[
                                                        value.imageId - 1
                                                        ];
                                                    return (
                                                        <div
                                                            className="complate-gift-container"
                                                            key={
                                                                index +
                                                                1 +
                                                                "_" +
                                                                indexU +
                                                                "_" +
                                                                indexL
                                                            }
                                                        >
                                                            <div
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    left:
                                                                        position.left,
                                                                    top:
                                                                        position.top,
                                                                    width:
                                                                        position.width,
                                                                    height:
                                                                        position.height,
                                                                    background: `url(${value.imageUrl
                                                                        }) no-repeat center / contain`
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            )}
                                        {unitGiftInfo &&
                                            unitGiftInfo.finish === false
                                            ? BGArr &&
                                            BGArr.map((value, index) =>
                                                Id && Id.length > 0 ? (
                                                    Id.indexOf(value) >= 0 ? (
                                                        <div
                                                            className={`bg-${value}`}
                                                            id={`bg${value}`}
                                                            key={
                                                                value +
                                                                "_" +
                                                                indexU +
                                                                "_" +
                                                                indexL
                                                            }
                                                        >
                                                            <div
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    height:
                                                                        "100%",
                                                                    background: `url(${Img[
                                                                        Id.indexOf(
                                                                            value
                                                                        )
                                                                    ]
                                                                        }) no-repeat center / contain`
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={`bg-${value}`}
                                                            id={`bg${value}`}
                                                            key={
                                                                value +
                                                                "_" +
                                                                indexU +
                                                                "_" +
                                                                indexL
                                                            }
                                                        />
                                                    )
                                                ) : (
                                                    <div
                                                        className={`bg-${value}`}
                                                        id={`bg${value}`}
                                                        key={
                                                            value +
                                                            "_" +
                                                            indexU +
                                                            "_" +
                                                            indexL
                                                        }
                                                    />
                                                )
                                            )
                                            : null}
                                    </div>
                                );
                            });
                        })}

                    {unitGiftInfo ? (
                        <div className="gift-content-image-container">
                            {/* {BGArr &&
            //   BGArr.map((value, index) =>
            //     tempStorageId && tempStorageId.length > 0 ? (
            //       tempStorageId.indexOf(value) >= 0 ? (
            //         <div
            //           className={`bg-${value}`}
            //           id={`bg${value}`}
            //           key={value}
            //         >
            //           <div
            //             style={{
            //               width: "100%",
            //               height: "100%",
            //               background: `url(${
            //                 tempStorageImg[tempStorageId.indexOf(value)]
            //               }) no-repeat center / contain`
            //             }}
            //           />
            //         </div>
            //       ) : (
            //         <div
            //           className={`bg-${value}`}
            //           id={`bg${value}`}
            //           key={value}
            //         />
            //       )
            //     ) : (
            //       <div
            //         className={`bg-${value}`}
            //         id={`bg${value}`}
            //         key={value}
            //       />
            //     )
            //   )} */}
                        </div>
                    ) : null}

                    {unitGiftInfoLessons ? (
                        <div className="gift-content-fragmant-container">
                            {unitGiftInfoLessons &&
                                Array.isArray(unitGiftInfoLessons) &&
                                unitGiftInfoLessons.map((value, index) =>
                                    value.locked === false ? (
                                        <div
                                            key={`${index}_${currentUnit.level
                                                }_${currentUnit.unit}`}
                                            id={`fragment${value.lesson}`}
                                        >
                                            <div
                                                className="gift-content-fragmant gray-image"
                                                draggable="false"
                                                style={{
                                                    background: `url(${value.imageUrl
                                                        }) no-repeat center / contain`,
                                                    left: `${FLeft +
                                                        125 * index}px`,
                                                    top: `${FTop}px`
                                                }}
                                            />
                                            {unitGiftInfo.finish === false &&
                                                (!tempStorageId ||
                                                    tempStorageId.indexOf(
                                                        value.imageId.toString()
                                                    ) < 0) ? (
                                                <div
                                                    style={{
                                                        background: `url(${value.imageUrl
                                                            }) no-repeat center / contain`,
                                                        left: `${FLeft +
                                                            125 * index}px`,
                                                        top: `${FTop}px`
                                                    }}
                                                    className="gift-content-fragmant"
                                                    draggable="false"
                                                    onMouseDown={e => {
                                                        this.MoveImageHandler(
                                                            value.imageId,
                                                            value.lesson,
                                                            value.imageUrl,
                                                            e
                                                        );
                                                    }}
                                                    onTouchStart={e => {
                                                        this.MoveImageHandler(
                                                            value.imageId,
                                                            value.lesson,
                                                            value.imageUrl,
                                                            e
                                                        );
                                                    }}
                                                    onTouchMove={e =>
                                                        this.fnMove(
                                                            value.imageId,
                                                            value.lesson,
                                                            e,
                                                            "touch"
                                                        )
                                                    }
                                                    onTouchEnd={e => {
                                                        this.fnUp(
                                                            value.imageId,
                                                            value.lesson,
                                                            value.imageUrl,
                                                            e
                                                        );
                                                    }}
                                                />
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div
                                            key={`${index}_${currentUnit.level
                                                }_${currentUnit.unit}`}
                                        >
                                            <div className="fragment-gift" />
                                            <div className="fragment-mask">
                                                <div className="fragment-mask-lock" />
                                            </div>
                                        </div>
                                    )
                                )}
                        </div>
                    ) : null}
                    {isEmptyGift ? (
                        <div className="no-gift-default">
                            <div className="no-gift-pic" />
                            <div className="no-gift-tips">
                                上完学习内容即可领取1份儿神秘礼物，赶快去学习吧~
                            </div>
                            <div
                                className="no-gift-go-class"
                                onClick={() =>
                                    (window.location.href = `${window.location.pathname}${window.location.search}#/path`)
                                }
                            >
                                去学习
                            </div>
                        </div>
                    ) : null}

                    {/* 如果是第一次进来，过几秒就出小手 */}
                    {FirstGift
                        ? newGuide && (
                            <div
                                className="my-gift-content-new-guide"
                                style={{
                                    position: "absolute",
                                    left: `${FLeft + 125 * newGuide.index}px`,
                                    top: `${FTop}px`
                                }}
                            >
                                <div
                                    className="my-gift-content-new-guide-img"
                                    style={{
                                        background: `url(${newGuide.imageUrl
                                            }) no-repeat center / contain`
                                    }}
                                />
                                <div
                                    className="my-gift-content-new-guide-hand"
                                    style={{}}
                                />
                            </div>
                        )
                        : null}
                </div>
                {/* 完成拼图后弹出的整图 */}
                {unitGiftInfo && showPuzzle ? (
                    <div className="my-gift-dialog-container">
                        <div
                            id="gift_piece"
                            className="dialog-complate-container"
                        >
                            <div className="dialog-complate-gift">
                                {unitGiftInfo.lessons &&
                                    Array.isArray(unitGiftInfo.lessons) &&
                                    unitGiftInfo.lessons.map((value, index) => {
                                        var position =
                                            Complate_Gift_Position[
                                            value.imageId - 1
                                            ];
                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    position: "absolute",
                                                    left: position.left,
                                                    top: position.top,
                                                    width: position.width,
                                                    height: position.height,
                                                    background: `url(${value.imageUrl
                                                        }) no-repeat center / contain`
                                                }}
                                            />
                                        );
                                    })}
                            </div>
                            <div
                                className="close-gift-puzzle"
                                onClick={() => {
                                    this.setState({ showPuzzle: false });
                                }}
                            >
                                关闭
                            </div>
                        </div>
                    </div>
                ) : null}

                {/* 用来添加音效 */}
                <audio autoPlay id="play-sound" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/route/MyGift.js